var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttach({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90773 11.038L11.0933 5.96277M3.96252 7.8656L2.66634 9.13421C2.32587 9.46744 2.05577 9.86309 1.87154 10.2985C1.68725 10.7339 1.59241 11.2006 1.59241 11.6718C1.59241 12.1431 1.68725 12.6098 1.87154 13.0452C2.05577 13.4806 2.32587 13.8762 2.66634 14.2095C3.00689 14.5427 3.41107 14.807 3.85592 14.9874C4.30085 15.1677 4.77763 15.2606 5.25914 15.2606C5.74065 15.2606 6.2175 15.1677 6.66236 14.9874C7.10721 14.807 7.51146 14.5427 7.85193 14.2095L9.14625 12.9409M7.851 4.05895L9.14718 2.79034C9.48766 2.45711 9.89191 2.19276 10.3368 2.01246C10.7817 1.83208 11.2585 1.73926 11.74 1.73926C12.2215 1.73926 12.6983 1.83208 13.1432 2.01246C13.5881 2.19276 13.9923 2.45711 14.3328 2.79034C14.6732 3.12364 14.9433 3.51922 15.1276 3.95461C15.3119 4.39007 15.4068 4.8567 15.4068 5.32797C15.4068 5.79931 15.3119 6.26594 15.1276 6.70133C14.9433 7.13679 14.6732 7.53237 14.3328 7.8656L13.0366 9.13421",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttach);
export default __webpack_public_path__ + "static/media/icon-attach.a327b3ebc2c07312ef9cf75d674e557e.svg";
export { ForwardRef as ReactComponent };